import { render, staticRenderFns } from "./PostListManage.vue?vue&type=template&id=28c7abe8"
import script from "./PostListManage.vue?vue&type=script&lang=ts"
export * from "./PostListManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports